import Vue from 'vue';

function clipboardSuccess() {
  Vue.prototype.$message({
    message: '复制成功',
    type: 'success',
    duration: 1500,
  });
}

function clipboardError() {
  Vue.prototype.$message({
    message: '复制失败，请尝试手动复制！',
    type: 'error',
  });
}

export default function copyToClipboard({ text, element }) {
  let copyText = text; // 默认复制传入的字符串

  // 如果传入的是元素，则尝试获取其内容
  if (element) {
    if (typeof element === 'string') {
      element = document.querySelector(element);
    }
    if (element && element.innerText) {
      copyText = element.innerText.trim();
    }
  }

  if (navigator.clipboard && window.isSecureContext) {
    // 使用Clipboard API来复制文字
    navigator.clipboard.writeText(copyText).then(function() {
      clipboardSuccess();
    }, function() {
      clipboardError();
    });
  } else {
    // 备选方法，使用textarea元素
    let textArea = document.createElement("textarea");
    textArea.value = copyText;
    textArea.style.whiteSpace = 'pre-wrap';
    textArea.style.position = "fixed";  // 避免滚动到底部
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      // 尝试执行复制操作
      const successful = document.execCommand('copy');
      if (successful) {
        clipboardSuccess();
      } else {
        clipboardError();
      }
    } catch (err) {
      clipboardError();
    }
    // 清理工作
    document.body.removeChild(textArea);
  }
}
